<section class="dashboard">
  <div class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h1>New Customer</h1>
        <p class="header-subtitle">Add a customer before defining rooms and windows.</p>
      </div>
      <div class="header-actions">
        <a class="action-button" routerLink="/jobs">
          ← Back
        </a>
      </div>
    </header>

    <div class="panel-card">
      <div class="panel-header">
        <h2>Customer Details</h2>
      </div>
      <div class="panel-content">
        <div class="form-grid">
          <div class="form-field-group">
            <label>Name</label>
            <input type="text" [(ngModel)]="form.name" placeholder="Customer name" class="form-input" />
          </div>
          <div class="form-field-group">
            <label>Builder</label>
            <input
              type="text"
              [(ngModel)]="form.builder"
              placeholder="Builder"
              class="form-input"
              list="builder-options"
            />
            <datalist id="builder-options">
              @for (builder of builderOptions(); track builder) {
                <option [value]="builder"></option>
              }
            </datalist>
          </div>
          <div class="form-field-group">
            <label>Model</label>
            <input
              type="text"
              [(ngModel)]="form.model"
              placeholder="Model"
              class="form-input"
              list="model-options"
            />
            <datalist id="model-options">
              @for (model of modelOptions(); track model) {
                <option [value]="model"></option>
              }
            </datalist>
          </div>
          <div class="form-field-group">
            <label>Elevation</label>
            <input
              type="text"
              [(ngModel)]="form.elevation"
              placeholder="Elevation"
              class="form-input"
              list="elevation-options"
            />
            <datalist id="elevation-options">
              @for (elevation of elevationOptions(); track elevation) {
                <option [value]="elevation"></option>
              }
            </datalist>
          </div>
          <div class="form-field-group">
            <label>Email</label>
            <input type="email" [(ngModel)]="form.email" placeholder="Email" class="form-input" />
          </div>
          <div class="form-field-group">
            <label>Phone</label>
            <input type="tel" [(ngModel)]="form.phone" placeholder="Phone" class="form-input" />
          </div>
          <div class="form-field-group">
            <label>Address</label>
            <input type="text" [(ngModel)]="form.address" placeholder="Address" class="form-input" />
          </div>
        </div>

        <button class="action-button primary" (click)="save()" [disabled]="saving()">
          {{ saving() ? "Saving..." : "Create customer" }}
        </button>
      </div>
    </div>

    @if (message(); as message) {
      <div class="status-message">{{ message }}</div>
    }
  </div>
</section>
